<article class="container">
    <section class="filters">
        <app-opportunities-filters
            [filtersKey]="filtersKey"
            [additionalFiltersVisibility]="filtersVisibility"
        ></app-opportunities-filters>
    </section>
    <section class="grid">
        <app-opportunities-list [filtersKey]="filtersKey" [accountId]="accountId()"></app-opportunities-list>
    </section>
</article>
